import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { ServiceConfig } from './service-config';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class ProjectsService {
  private host = ServiceConfig.host;
  public baseUrl = this.host + '/api/projects/';
  public baseUrlBrand = this.host + '/api/brand-manage/';
  public data: any;
  public headers: Headers;
  public options: {};

  constructor(private http: HttpClient) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = { headers: this.headers };
  }

  public indexAll() {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    const url = this.baseUrl + 'all?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public index() {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    const url = this.baseUrl + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public getProjectsByBrand(body) {
    let url = this.baseUrl + 'all?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getProjectDiscussionByProject(body) {
    const url = this.baseUrl + 'getProjectDiscussion?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getProjectDiscussionByGroup(body) {
    const url = this.baseUrl + 'getProjectDiscussionByGroup?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getGroupDiscussion(body) {
    const url = this.baseUrl + 'getGroupDiscussion?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getBrandsActive() {
    const url = this.baseUrlBrand + 'getActive?token=' + this.data.token;
    return this.http.get<any>(url);
  }


  public getBrandsActiveV2() { // có phân quyền
    const url = this.baseUrlBrand + 'getActive?token=' + this.data.token;
    return this.http.post<any>(url, {});
  }

  public create(body) {
    const url = this.baseUrl + 'create?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public get(projectId: String) {
    const url = this.baseUrl + projectId + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public update(projectId: String, body) {
    const url = this.baseUrl + projectId + '/update?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public delete(projectId: String, body) {
    const url = this.baseUrl + projectId + '/delete?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public updateRole(body) {
    const url = this.baseUrl + 'updateRole?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public updateRoleBrand(body) {
    const url = this.baseUrl + 'updateRoleBrand?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public updateRoleMultiProjects(body) {
    const url = this.baseUrl + 'updateDepartmentProject?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public updateStatus(body) {
    const url = this.baseUrl + 'updateStatus?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getProjectByIds(body) {
    const url = this.baseUrl + 'getProjectByIds?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getProjectByDepartment(body) {
    const url = this.baseUrl + 'projects-department?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/projects.service.ts